export default __webpack_public_path__ + "static/media/hamburger-menu.2f4f56f6.svg";